var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2023 Félix Robles <felix@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { createContext, useContext, useState } from "react";
var defaultElectionContext = {
    ElectionId: null,
    setElectionId: function () { return undefined; },
};
export var ElectionContext = createContext(defaultElectionContext);
export var ElectionContextProvider = function (props) {
    var _a = useState(localStorage.getItem("selected-election-event-id") || null), Election = _a[0], setElection = _a[1];
    var setElectionId = function (ElectionId) {
        localStorage.setItem("selected-election-event-id", ElectionId || "");
        setElection(ElectionId);
    };
    // Setup the context provider
    return (_jsx(ElectionContext.Provider, __assign({ value: {
            ElectionId: Election,
            setElectionId: setElectionId,
        } }, { children: props.children })));
};
export var useElectionStore = function () {
    var _a = useContext(ElectionContext), ElectionId = _a.ElectionId, setElectionId = _a.setElectionId;
    return [ElectionId, setElectionId];
};
